'use client';

import { c as _c } from "react/compiler-runtime";
import { LoaderStrip } from '@shared/ui-components/loader-strip/loader-strip';
import { useGlobalLoaderContext } from '../providers/global-loader-context';
export const LoaderStripContainer = () => {
  const $ = _c(4);
  const {
    isNonBlockingLoaderVisible
  } = useGlobalLoaderContext();
  let t0;
  if ($[0] !== isNonBlockingLoaderVisible) {
    t0 = isNonBlockingLoaderVisible && <LoaderStrip isSecondaryVariant={true} />;
    $[0] = isNonBlockingLoaderVisible;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <>{t0}</>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};